import { useParams } from "react-router-dom";
import MenuFrame from "../frames/menu_frame";
import { Avatar, Box, Button, Chip, createTheme, Divider, IconButton, Link, List, ListItemAvatar, ListItemButton, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { AddCircleTwoTone, CableTwoTone, EditTwoTone, FlightTwoTone, GifBoxTwoTone, RemoveCircleTwoTone, TrainTwoTone } from "@mui/icons-material";
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';
import LocalPostOfficeTwoToneIcon from '@mui/icons-material/LocalPostOfficeTwoTone';
import Inventory2TwoToneIcon from '@mui/icons-material/Inventory2TwoTone';
import BoltTwoToneIcon from '@mui/icons-material/BoltTwoTone';
import { getBilledData, getInvoiceFuel, getInvoiceGst, getInvoicePrice, getInvoiceTaxable, getInvoiceTotalPrice, getTotalPrice } from "./billing_halper";
import Loading2 from "../frames/loading2";
import { useState } from "react";
import { blue, green, red } from "@mui/material/colors";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import NewBillItem from "./new_item";
import BillPriview from "./priview";
import { getClient } from "../client/client_halper";

function Billing() {
    const params = useParams();
    const [openPriview, setOpenPriview] = useState(false);
    const [clientInfo, setClientInfo] = useState(null);
    const [newItem, setNewItem] = useState(false);
    const [selected, setSelected] = useState(null);
    const [available, setAvailable] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const dayTheme = createTheme();

    var tmp_res = null;
    const handleNewItemClose = () => {
        setNewItem(false);
    }

    const handleNewItemSave = (item) => {
        item.sl_no = selected.length + available.length + 1;
        setSelected([...selected, item])
    }

    const switchToBill = (item) => {
        if (item.total === 0) return;
        setAvailable(available.filter((itm) => itm !== item));
        setSelected([...selected, item])
    }

    const moveToAvailable = (item) => {
        setSelected(selected.filter((itm) => itm !== item));
        setAvailable([...available, item])
    }

    const handlePreviewClose = (result) => {
        if (result === "success") {
            setSelected([]);
        }
        setOpenPriview(false);
    }

    const handlePreview = (e) => {
        if (selected.length !== 0) setOpenPriview(true);
    }


    const stringToIcon = (text) => {
        return text.split(/(Document|Parcel|Electronic|Gift|Surface|Air|Premium|Standard)/g).map((part, index) => {
            if (part === "Document") return <Tooltip title="Document"><LocalPostOfficeTwoToneIcon key={index} color="secondary" fontSize="inherit" /></Tooltip>;
            if (part === "Parcel") return <Tooltip title="Parcel"><Inventory2TwoToneIcon key={index} color="secondary" fontSize="inherit" /></Tooltip>;
            if (part === "Electronic") return <Tooltip title="Electronic"><CableTwoTone key={index} color="secondary" fontSize="inherit" /></Tooltip>;
            if (part === "Gift") return <Tooltip title="Gift"><GifBoxTwoTone key={index} color="secondary" fontSize="inherit" /></Tooltip>;
            if (part === "Surface") return <Tooltip title="Surface"><LocalShippingTwoToneIcon key={index} color="secondary" fontSize="inherit" /></Tooltip>;
            if (part === "Air") return <Tooltip title="Air"><FlightTwoTone key={index} color="secondary" fontSize="inherit" /></Tooltip>;
            if (part === "Premium") return <Tooltip title="Premium"><BoltTwoToneIcon key={index} color="secondary" fontSize="inherit" /></Tooltip>;
            if (part === "Standard") return <Tooltip title="Standard"><TrainTwoTone key={index} color="secondary" fontSize="inherit" /></Tooltip>;
            return part;
        });
    }

    if (available === null) {
        setAvailable([]);
        getClient(params.client, "billing").then((res) => {
            setClientInfo(res);
            tmp_res = res;
            return getBilledData(params.client);
        }).then((res) => {
            const booking = res["996812"];
            const pickup = res["996512"];
            const packaging = res["998540"];
            const insurance = res["9971"];
            var items = [];
            var sl = 1;
            for (let idx = 0; idx < booking.length; idx++, sl++) {
                const element = booking[idx];
                let rate = getTotalPrice(booking, pickup, packaging, element.cn_no, tmp_res);
                let price = Number((element.amount + element.other).toFixed(2));
                let fuel = Number((price * rate.fuel / 100).toFixed(2));
                let gst = Number(((price + fuel) * rate.gst / 100).toFixed(2));
                if (gst === 0) {
                    element.amount = Number((element.amount * 100 / 118).toFixed(2));
                    element.other = Number((element.other * 100 / 118).toFixed(2));
                    price = Number((price * 100 / 118).toFixed(2));
                    fuel = Number((fuel * 100 / 118).toFixed(2));
                    gst = Number(((price + fuel) * 0.18).toFixed(2));
                }
                items.push({
                    "id": element.cn_no,
                    "sl_no": sl,
                    "date": element.created,
                    "title": element.cn_no,
                    "description": element.method + (element.type ? " | " + element.type : ""),
                    "hsn": 996812,
                    "quantity": 1,
                    "weight": element.weight,
                    "destination": element.destination + (element.destination && element.pincode ? " - " + element.pincode : element.pincode),
                    "rate": element.amount,
                    "other": element.other,
                    "price": price,
                    "fuel": fuel,
                    "gst": gst
                });
            }
            for (let idx = 0; idx < pickup.length; idx++, sl++) {
                const element = pickup[idx];
                let rate = getTotalPrice(booking, pickup, packaging, element.cn_ref, tmp_res);
                let price = Number((element.amount).toFixed(2));
                let fuel = Number((price * rate.fuel / 100).toFixed(2));
                let gst = Number(((price + fuel) * rate.gst / 100).toFixed(2));
                if (gst === 0) {
                    price = Number((price * 100 / 118).toFixed(2));
                    fuel = Number((fuel * 100 / 118).toFixed(2));
                    gst = Number(((price + fuel) * 0.18).toFixed(2));
                }
                items.push({
                    "id": String(element.pick_id),
                    "sl_no": sl,
                    "date": element.created,
                    "title": "Pickup",
                    "description": element.description,
                    "hsn": 996512,
                    "quantity": 1,
                    "weight": undefined,
                    "destination": undefined,
                    "rate": price,
                    "other": 0,
                    "price": price,
                    "fuel": fuel,
                    "gst": gst
                });
            }
            for (let idx = 0; idx < packaging.length; idx++, sl++) {
                const element = packaging[idx];
                let rate = getTotalPrice(booking, pickup, packaging, element.cn_ref, tmp_res);
                let price = Number((element.amount).toFixed(2));
                let fuel = Number((price * rate.fuel / 100).toFixed(2));
                let gst = Number(((price + fuel) * rate.gst / 100).toFixed(2));
                if (gst === 0) {
                    price = Number((price * 100 / 118).toFixed(2));
                    fuel = Number((fuel * 100 / 118).toFixed(2));
                    gst = Number(((price + fuel) * 0.18).toFixed(2));
                }
                items.push({
                    "id": String(element.pack_id),
                    "sl_no": sl,
                    "date": element.created,
                    "title": "Packaging",
                    "description": element.description,
                    "hsn": 998540,
                    "quantity": 1,
                    "weight": undefined,
                    "destination": undefined,
                    "rate": price,
                    "other": 0,
                    "price": price,
                    "fuel": fuel,
                    "gst": gst
                });
            }
            for (let idx = 0; idx < insurance.length; idx++, sl++) {
                const element = insurance[idx];
                let price = Number(((element.amount * 100) / 118).toFixed(2));
                let gst = Number((price * 0.18).toFixed(2));
                if (gst === 0) {
                    price = Number((price * 100 / 118).toFixed(2));
                    gst = Number(((price) * 0.18).toFixed(2));
                }
                items.push({
                    "id": String(element.insurance_id),
                    "sl_no": sl,
                    "date": element.created,
                    "title": "Insurance by DTDC Express Ltd",
                    "description": element.description,
                    "hsn": 9971,
                    "quantity": 1,
                    "weight": undefined,
                    "destination": undefined,
                    "rate": price,
                    "other": 0,
                    "price": price,
                    "fuel": 0,
                    "gst": gst
                });
            }
            setAvailable(items);
            setSelected([]);
            setIsLoading(false);
            return;
        }).catch((err) => {
            console.log(err);
        });
    }

    if (isLoading) return (<MenuFrame permission="BILLING_ORG"><Loading2 /></MenuFrame>);
    return (
        <MenuFrame permission="BILLING_ORG">
            <BillPriview particular={selected} open={openPriview} onClose={handlePreviewClose} client={clientInfo} />
            <Typography variant="subtitle1" color="textPrimary" sx={{ mb: 1, mt: 1 }}>Client Code: {params.client}</Typography>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="" className="nowrap">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell align="right">HSN</TableCell>
                            <TableCell align="right">Quantity</TableCell>
                            <TableCell align="right">Rate</TableCell>
                            <TableCell align="right">Price</TableCell>
                            <TableCell align="right">Fuel</TableCell>
                            <TableCell align="right">Taxable</TableCell>
                            <TableCell align="right">GST</TableCell>
                            <TableCell align="right">Total</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selected.length === 0 ? <TableRow><TableCell colSpan={11}><Typography textAlign={"center"} color="textDisabled" variant="caption">No data</Typography></TableCell></TableRow> :
                            selected.map((row, idx) => (
                                <TableRow key={idx}>
                                    <TableCell width={20}>
                                        <IconButton aria-label="remove" size="small" onClick={() => { moveToAvailable(row); }}>
                                            <RemoveCircleTwoTone color="warning" fontSize="inherit" />
                                        </IconButton>
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.date}
                                    </TableCell>
                                    <TableCell>{row.title}{row.description ? <br /> : ""}{stringToIcon(row.description)} {row.destination ? <br /> : ""} {row.destination}</TableCell>
                                    <TableCell align="right">{row.hsn}</TableCell>
                                    <TableCell align="right">{row.quantity}</TableCell>
                                    <TableCell align="right">{row.rate}</TableCell>
                                    <TableCell align="right">
                                        {row.price.toFixed(2)}
                                        {row.other !== 0 ? Math.abs(row.other) < 10 ?
                                            <Typography variant="caption"><br />Adjustment: {row.other.toFixed(2)}</Typography> :
                                            row.other < 0 ? <Typography variant="caption"><br />Discount: {row.other.toFixed(2)}</Typography> :
                                                <Typography variant="caption"><br />Other: {row.other.toFixed(2)}</Typography> : ""}
                                    </TableCell>
                                    <TableCell align="right">{row.fuel.toFixed(2)}</TableCell>
                                    <TableCell align="right">{(row.price + row.fuel).toFixed(2)}</TableCell>
                                    <TableCell align="right">{row.gst.toFixed(2)}</TableCell>
                                    <TableCell align="right">{(row.price + row.fuel + row.gst).toFixed(2)}</TableCell>
                                </TableRow>
                            ))}
                        <NewBillItem open={newItem} onClose={handleNewItemClose} onSuccess={handleNewItemSave} />
                        <TableRow>
                            <TableCell colSpan={11}>
                                <Button fullWidth style={{ border: "1px dashed #0288d1" }} onClick={() => { setNewItem(true); }}>
                                    <IconButton aria-label="delete" size="small" component={Box}>
                                        <AddCircleTwoTone color="info" fontSize="inherit" />
                                    </IconButton>
                                </Button>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={11}>
                                <Button variant="contained" color="primary" fullWidth onClick={handlePreview}>
                                    Preview
                                </Button>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <br />
            <Divider><Chip label="Available" size="small" /></Divider>
            <br />
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="" className="nowrap">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell align="right">HSN</TableCell>
                            <TableCell align="right">Quantity</TableCell>
                            <TableCell align="right">Rate</TableCell>
                            <TableCell align="right">Price</TableCell>
                            <TableCell align="right">Fuel</TableCell>
                            <TableCell align="right">Taxable</TableCell>
                            <TableCell align="right">GST</TableCell>
                            <TableCell align="right">Total</TableCell>
                        </TableRow>
                    </TableHead>
                    <ThemeProvider theme={dayTheme}>
                        <TableBody>
                            {available.length === 0 ? <TableRow><TableCell colSpan={11}><Typography textAlign={"center"} color="textDisabled" variant="caption">No data</Typography></TableCell></TableRow> :
                                available.map((row, idx) => (
                                    <TableRow key={idx} style={{ background: row.price ? green[50] : red[50] }}>
                                        <TableCell width={20}>
                                            {row.price ?
                                                <IconButton aria-label="add" size="small" onClick={() => { switchToBill(row); }}>
                                                    <AddCircleTwoTone color="success" fontSize="inherit" />
                                                </IconButton> :
                                                <IconButton aria-label="edit" size="small" component={Link} href={"/correction/org-booking/" + params.client} style={{ cursor: "alias" }}>
                                                    <EditTwoTone color="warning" fontSize="inherit" />
                                                </IconButton>
                                            }
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.date}
                                        </TableCell>
                                        <TableCell>{row.title} {row.description ? <br /> : ""}{stringToIcon(row.description)} {row.destination ? <br /> : ""} {row.destination}</TableCell>
                                        <TableCell align="right">{row.hsn}</TableCell>
                                        <TableCell align="right">{row.quantity}</TableCell>
                                        <TableCell align="right">{row.rate}</TableCell>
                                        <TableCell align="right">
                                            {row.price.toFixed(2)}
                                            {row.other !== 0 ? Math.abs(row.other) < 10 ?
                                                <Typography variant="caption"><br />Adjustment: {row.other.toFixed(2)}</Typography> :
                                                row.other < 0 ? <Typography variant="caption"><br />Discount: {row.other.toFixed(2)}</Typography> :
                                                    <Typography variant="caption"><br />Other: {row.other.toFixed(2)}</Typography> : ""}
                                        </TableCell>
                                        <TableCell align="right">{row.fuel.toFixed(2)}</TableCell>
                                        <TableCell align="right">{(row.price + row.fuel).toFixed(2)}</TableCell>
                                        <TableCell align="right">{row.gst.toFixed(2)}</TableCell>
                                        <TableCell align="right">{(row.price + row.fuel + row.gst).toFixed(2)}</TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </ThemeProvider>
                </Table>
            </TableContainer>

            <List sx={{ backgroundColor: 'background.paper' }} dense>
                <ListItemButton>
                    <ListItemAvatar>
                        <Avatar>
                            <CurrencyRupeeIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Base Price" secondary={getInvoicePrice(selected)} sx={{ color: "text.primary" }} />
                </ListItemButton>
                <ListItemButton>
                    <ListItemAvatar>
                        <Avatar>
                            <CurrencyRupeeIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Fuel Chaarge" secondary={getInvoiceFuel(selected)} sx={{ color: "text.primary" }} />
                </ListItemButton>
                <ListItemButton>
                    <ListItemAvatar>
                        <Avatar>
                            <CurrencyRupeeIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Taxable Amount" secondary={getInvoiceTaxable(selected)} sx={{ color: "text.primary" }} />
                </ListItemButton>
                <ListItemButton>
                    <ListItemAvatar>
                        <Avatar>
                            <CurrencyRupeeIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="GST (CGST and SGST)" secondary={getInvoiceGst(selected)} sx={{ color: "text.primary" }} />
                </ListItemButton>
                <ListItemButton style={{ backgroundColor: "primary.background", color: blue[700] }}>
                    <ListItemAvatar>
                        <Avatar sx={{ backgroundColor: blue[100] }}>
                            <CurrencyRupeeIcon htmlColor={blue[700]} />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Bill Amount" secondary={getInvoiceTotalPrice(selected)} sx={{ color: "text.primary" }} />
                </ListItemButton>
            </List>
        </MenuFrame>
    );
}

export default Billing;